import { DiagnosisItem, MalocclusionsOptions } from "../../diagnosis.model";
import { Tooth } from "../../../../odontogram/odontogram.model";
import { ItemValidators } from "../../../item-validators";
import { AbstractCondition } from "../condition";

export class Malocclusions extends AbstractCondition {
  static validate(
    item: DiagnosisItem,
    odontogram: Tooth[],
    items: DiagnosisItem[],
  ): boolean {
    // validate options
    if (!ItemValidators.hasOptionObjectSelected(item)) {
      return false;
    }

    return true;
  }

  static apply(odontogram: Tooth[], item: DiagnosisItem): Tooth[] {
    return odontogram;
  }

  static getDiagnosis360Changes(item): any {
    if (
      item.options.malo_class > 1 ||
      item.options.midline_shift ||
      item.options.crowding ||
      item.options.spacing ||
      item.options.overlap ||
      item.options.bite ||
      item.options.crossbit ||
      item.options.disharmony
    ) {
      return {
        crooked_shifting: true,
      };
    }

    return null;
  }

  static getDescriptionIdentifiers(item): string[] {
    const identifiers = ["malocclusions"];

    if (item.options.malo_class > 1) {
      identifiers.push("malocclusions_occlusion_" + item.options.malo_class);
    }
    if (item.options.midline_shift) {
      identifiers.push("malocclusions_midline_shift");
    }
    if (item.options.crowding) {
      identifiers.push("malocclusions_crowding");
    }
    if (item.options.spacing) {
      identifiers.push("malocclusions_spacing");
    }
    if (item.options.overlap) {
      identifiers.push("malocclusions_overlap_" + item.options.overlap);
    }
    if (item.options.bite) {
      identifiers.push("malocclusions_bite_" + item.options.bite);
    }
    if (item.options.crossbit) {
      identifiers.push("malocclusions_crossbite");
    }
    if (item.options.disharmony) {
      identifiers.push("malocclusions_skeletal_disharm");
    }

    return identifiers;
  }

  static isActive(options: MalocclusionsOptions) {
    return (
      options.malo_class !== 1 ||
      options.midline_shift ||
      options.crowding ||
      options.spacing ||
      options.overlap !== "" ||
      options.bite !== "" ||
      options.crossbit ||
      options.disharmony
    );
  }

  static supports(condition: string): boolean {
    return condition === "malocclusions";
  }
}



// WEBPACK FOOTER //
// /app/src/app/core/store/plan-editor/diagnosis/conditions/ortho/malocclusions.ts